import { Tooltip } from "antd";
import moment from "moment";

import Icon from "@assets/icon_config";
import { useRemindersContext } from "./useReminders";
import { useMembersContext } from "@pages/members/useMembers";
import { REMINDER_VIEW_TYPES } from "./constant";

function getReminderStatusToolTip(data: any) {
  const thresholdDate = moment().subtract(30, "days").format("MM/DD/YYYY");
  const currentDate = moment().format("MM/DD/YYYY");

  return (
    <div className="reminder-drawer__header__reminder-statistics__tooltip-container">
      <div className="reminder-drawer__header__reminder-statistics__tooltip-container__status">
        <div className="reminder-drawer__header__reminder-statistics__tooltip-container__status__dot" style={{ background: data?.colorCode }} />
      </div>
      <div className="reminder-drawer__header__reminder-statistics__tooltip-container__data">
        <span className="reminder-drawer__header__reminder-statistics__tooltip-container__data__count-bold">{data?.value}</span>
        {` ${data?.label} Reminders.`}
        <br />
        <span className="reminder-drawer__header__reminder-statistics__tooltip-container__data__time-stamp">{`${thresholdDate} to ${currentDate}`}</span>
      </div>
    </div>
  );
}

export const getTimeZone = () => {
  // return `${moment().tz(moment.tz.guess()).format("zz")}`;
  return new Date().toLocaleDateString(undefined, { day: "2-digit", timeZoneName: "long" }).substring(4);
};

export const getDiffFromCurrent = (date: any) => {
  return moment().startOf("day").diff(moment(date).startOf("day"), "day");
};

// Function to check if a date is within the current week
export function isInCurrentWeek(date : any) {

  // Get the start and end dates of the current week
  const startOfWeek = moment().startOf('week');
  const endOfWeek = moment().endOf('week');

  // Check if the given date falls within the current week
  if(moment.isMoment(date)) {
    return date.isBetween(startOfWeek, endOfWeek, null, '[]');
  }
  return moment(date).isBetween(startOfWeek, endOfWeek, null, '[]');
}

// Function to check if a date is within the current month
export function isInCurrentMonth(date : any) {
  // Get the start and end dates of the current month
  const startOfMonth = moment().startOf('month');
  const endOfMonth = moment().endOf('month');

  // Check if the given date falls within the current month
  if(moment.isMoment(date)) {
    return date.isBetween(startOfMonth, endOfMonth, null, '[]');
  }
  return moment(date).isBetween(startOfMonth, endOfMonth, null, '[]');
}

// Red dot to show that reminder exists on the specified day ( antd date picker )
export const getCalFormattedDate = (current: any , filteredDates : any) => {
  let showDot = false;
  const dateKey = current.startOf("day").unix() + "-" + current.endOf("day").unix();
  if (filteredDates?.includes(dateKey)) {
    showDot = true;
  }
  return (
    <div className="ant-picker-cell-inner">
      {showDot && <span className="dateDot"></span>}
      {current.date()}
    </div>
  );
};

export function ViewButtons() {

  const {sidebarExpand} = useMembersContext();

  const {viewType , handleViewTypeChange} = useRemindersContext();

  return (
    <div>
      {sidebarExpand && REMINDER_VIEW_TYPES.map((view : string) => (
        <PrimaryButton isActive={view === viewType} clickHandler={handleViewTypeChange} label={view}/>
      ))}
    </div>
  );
}

export function PrimaryButton({isActive , clickHandler , label} : {isActive : boolean , clickHandler : any , label : string}) {

  function handleClick(e : any) {
    if(!isActive) {
      clickHandler(label , e)
    }
  }

  return (
    <span className={`reminder-drawer__header__reminder-views ${isActive ? 'active' : ''}`} onClick={(e) => handleClick(e)}>{label}</span>
  )
}

export function KpiDataMap({ KpiData }: { KpiData: any[] }) {
  return (
    <div className="reminder-drawer__header__reminder-statistics">
      {KpiData?.map((item: any) => (
        <Tooltip placement="bottom" title={getReminderStatusToolTip({ ...item })} overlayClassName="reminder-drawer__header__reminder-statistics__tooltip">
          <div className="reminder-drawer__header__reminder-statistics__status" style={{ background: item.colorCode }}>
            {item?.value}
          </div>
        </Tooltip>
      ))}
      </div>
  );
}

export function CloseIcon({ closeDrawer }: { closeDrawer: () => void }) {
  return (
    <div className="reminder-drawer__header__reminder-statistics__close" onClick={() => closeDrawer()}>
      <Icon name="close" />
    </div>
  );
}

export function ReminderTimeZone() {
  return <span className="header-timeZone-format">Time Zone : {getTimeZone()}</span>
}